<template>
  <div>
    <Waiting v-if="loading" />
    <v-btn
      round
      class="green white--text text-none mx-5 mb-3"
      @click="savePDF"
      v-show="showSavePDFBtn"
    >
      Save As PDF
    </v-btn>
    <div class="separator-save-pdf" :hidden="isHide"></div>
    <div
      id="invoice-pdf"
      class="invoice-box"
      ref="content"
      :hidden="isHide"
      v-bind:style="{ width: '650px' }"
    >
      <table cellpadding="0" cellspacing="0">
        <tr class="top">
          <td colspan="2">
            <table>
              <tr v-if="summary.company">
                <td>
                  <label class="font-weight-bold ">
                    {{ summary.company.name ? summary.company.name : '-' }}
                  </label>
                </td>

                <td class="title">
                  <img
                    src="./../../public/logo.png"
                    style="width: 100%; max-width: 100px"
                  />
                </td>
              </tr>
              <tr v-if="summary.company" class="caption">
                <td>
                  {{ summary.company.address ? summary.company.address : '-' }}
                  <br />
                  {{ summary.company.city ? summary.company.city : '-' }}
                  {{
                    summary.company.postal_code
                      ? summary.company.postal_code
                      : '-'
                  }}
                  <br />
                  <label class="font-weight-bold">
                    NPWP :
                    {{ summary.company.npwp ? summary.company.npwp : '-' }}
                  </label>
                </td>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td class="font-weight-bold caption" colspan="1">
                          INVOICE #
                        </td>
                        <td>:</td>
                        <td class="caption">
                          {{ summary.distributor_balance_order_number }}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold caption" colspan="1">
                          DATE
                        </td>
                        <td>:</td>
                        <td class="caption">{{ summary.created_date }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td class="horizontal-divider"><hr /></td>
          <td class="horizontal-divider">
            <!-- <label>INVOICE</label> -->
            <hr />
          </td>
        </tr>
      </table>

      <table class="mt-4">
        <tr>
          <td>CUSTOMER</td>
        </tr>
        <tr class="caption">
          <td class="pl-0">
            <table class="customer-data-table">
              <tr>
                <td>
                  NAME
                </td>
                <td>{{ $store.state.username }}</td>
              </tr>
              <tr>
                <td>
                  EMAIL
                </td>
                <td>{{ $store.state.receiver }}</td>
              </tr>
            </table>
          </td>
          <td class="pr-0">
            <table class="customer-data-table">
              <tr>
                <td>
                  ORDER
                </td>
                <td>{{ summary.distributor_balance_order_number }}</td>
              </tr>
              <tr>
                <td>
                  DUE DATE
                </td>
                <td>{{ summary.va_expired_at }}</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>

      <table border="1" class="invoice-items caption">
        <tr>
          <td>
            NO.
          </td>
          <td>DESCRIPTION</td>
          <td>PAYMENT FEE</td>
          <td>AMOUNT</td>
          <td>TOTAL</td>
        </tr>
        <tr>
          <td>
            1.
          </td>
          <td>
            Top Up Deposit
          </td>
          <td>
            {{ summary.va_payment_fee }}
          </td>
          <td>
            {{ summary.amount }}
          </td>
          <td>
            {{ summary.va_gross_amount }}
          </td>
        </tr>
      </table>

      <table class="payment-info">
        <tr>
          <p class="font-weight-bold text-xs-left mb-1">PAYMENT DETAIL</p>
        </tr>
        <tr>
          <table class="payment-detail caption">
            <tr>
              <td>BANK NAME:</td>
              <td>{{ summary.payment_method_name }}</td>
            </tr>
            <tr>
              <td>BANK ACCOUNT NUMBER:</td>
              <td>{{ summary.va_no }}</td>
            </tr>
            <tr>
              <td>BANK ACCOUNT NAME:</td>
              <td>{{ summary.va_account_holder_name }}</td>
            </tr>
          </table>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { jsPDF } from 'jspdf'
import domtoimage from 'dom-to-image'
import Waiting from '@/components/Waiting.vue'

export default {
  name: 'Invoice',
  components: { Waiting },
  data () {
    return { showSavePDFBtn: true, isHide: true, loading: false }
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    onPrepare: {
      type: Function,
      default: () => {}
    },
    title: {
      type: String,
      default: 'Modal Title'
    },
    summary: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    scrollToTop () {
      const element = document.getElementById('success-modal-body')
      element.scrollIntoView()
    },
    savePDF () {
      this.onPrepare()
      this.scrollToTop()
      this.showSavePDFBtn = false
      this.isHide = false
      this.loading = true
      domtoimage
        .toPng(this.$refs.content, {
          quality: 0.99,
          width: 650,
          height: 1000
        })
        .then(function (dataUrl) {
          const img = new Image()
          img.src = dataUrl
          // eslint-disable-next-line
          const doc = new jsPDF({
            orientation: 'portrait'
            // unit: 'pt',
            // format: [900, 1400]
          })
          doc.addImage(img, 'JPEG', 20, 20)
          const date = new Date()
          const filename =
            'Invoice_' +
            date.getFullYear() +
            ('0' + (date.getMonth() + 1)).slice(-2) +
            ('0' + date.getDate()).slice(-2) +
            ('0' + date.getHours()).slice(-2) +
            ('0' + date.getMinutes()).slice(-2) +
            ('0' + date.getSeconds()).slice(-2) +
            '.pdf'
          doc.save(filename)
        })
        .then(() => {
          this.showSavePDFBtn = true
          this.isHide = true
          this.loading = false
        })
        .catch(function (error) {
          alert('oops, something went wrong when generate PDF.', error)
        })
    }
  }
}
</script>
<style scoped>
.separator-save-pdf {
  margin-bottom: 3em !important;
}

.invoice-box {
  max-width: 800px;
  /* margin: auto; */
  padding: 30px;
  border: 1px solid #eee;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  font-size: 16px;
  line-height: 24px;
  font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
  color: #555;
}

.invoice-box table {
  width: 100%;
  line-height: inherit;
  text-align: left;
}

.invoice-box table td {
  padding: 5px;
  vertical-align: top;
}

.invoice-box table tr td:nth-child(2) {
  text-align: right;
}

.invoice-box table tr.top table td {
  padding-bottom: 20px;
}

.invoice-box table tr.top table td table tr td {
  padding-bottom: 0px;
  padding-top: 0px;
}

.invoice-box table tr.top table td.title {
  font-size: 45px;
  line-height: 45px;
  color: #333;
}

.invoice-box table tr.information table td {
  padding-bottom: 40px;
}

.invoice-box table tr.heading td {
  background: #eee;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
}

.invoice-box table tr.details td {
  padding-bottom: 20px;
}

.invoice-box table tr.item td {
  border-bottom: 1px solid #eee;
}

.invoice-box table tr.item.last td {
  border-bottom: none;
}

.invoice-box table tr.total td:nth-child(2) {
  border-top: 2px solid #eee;
  font-weight: bold;
}

@media only screen and (max-width: 600px) {
  .invoice-box table tr.top table td {
    width: 100%;
    display: block;
    text-align: center;
  }

  .invoice-box table tr.information table td {
    width: 100%;
    display: block;
    text-align: center;
  }
}

/** RTL **/
.invoice-box.rtl {
  direction: rtl;
  font-family: Tahoma, 'Helvetica Neue', 'Helvetica', Helvetica, Arial,
    sans-serif;
}

.invoice-box.rtl table {
  text-align: right;
}

.invoice-box.rtl table tr td:nth-child(2) {
  text-align: left;
}

tr td.horizontal-divider {
  padding: 0;
}

.invoice-box table tr.information td table.customer-data-table td {
  padding-bottom: 0px;
}

table.customer-data-table {
  background-color: #ffffff;
  opacity: 0.95;
  border: 1px solid black;
  border-collapse: collapse;
  text-align: left;
}

.customer-data-table td {
  text-align: left !important;
}

table.invoice-items {
  background-color: #ffffff;
  border: 1px solid black;
  border-collapse: collapse;
  text-align: left;
  margin-top: 30px;
  margin-bottom: 30px;
}

.invoice-items td {
  text-align: left !important;
}

.invoice-items td:nth-child(1) {
  width: 10px;
}

.invoice-items td:nth-child(2) {
  width: 275px;
}

.invoice-items td:nth-child(3) {
  width: 125px;
}

.invoice-items td:nth-child(4) {
  width: 150px;
}

.payment-info {
  margin-top: 15em;
}

table.payment-detail {
  background-color: #ffffff;
  opacity: 0.95;
  border: 1px solid black;
  border-collapse: collapse;
  text-align: left;
  width: 50%;
}

.payment-detail td {
  text-align: left !important;
}
</style>
